
import { AfterViewInit, Component, ViewEncapsulation } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { fuseAnimations } from '@fuse/animations';
import { TranslateService } from '@ngx-translate/core';
import { AppInitializationService } from 'app/app-initialization.service';
import { Car } from 'app/models/car.model';
import { Container } from 'app/models/container.model';
import { Device } from 'app/models/device.model';
import { Envanter } from 'app/models/envanter.model';
import { Poligon, PoligonDetail } from 'app/models/poligon.model';
import { User } from 'app/models/user.model';
import { CarService } from 'app/services/car.service';
import { ContainerService } from 'app/services/container.service';
import { DateConvertService } from 'app/services/date-convert.service';
import { DeviceService } from 'app/services/device.service';
import { EnvanterService } from 'app/services/envanter.service';
import { PoligonService } from 'app/services/poligon.service';
import { ToasterService } from 'app/services/user-interaction/services/toaster.service';
import * as L from 'leaflet';
import 'leaflet-draw';
import '../../../../../../../node_modules/leaflet.browser.print/dist/leaflet.browser.print.min.js';
import { EnvanterFormComponent } from '../envanter-form/envanter-form.component';
import { GarbageCenterFormComponent } from '../garbage-center-form/garbage-center.component';
import { MapContainerFormComponent } from '../map-container-form/map-container-form.component';
import { MarkerFormComponent } from '../marker-form/marker-form.component';
import { PoligonFormComponent } from '../poligon-form/poligon-form.component';

const iconUrl = 'assets/img/marker-icon.png';
const iconDefault = L.icon({
    iconUrl,
    iconSize: [25, 25],
    popupAnchor: [1, -34],
    tooltipAnchor: [16, -28]
});
const ContainerIcon = L.Icon.extend({
    options: {
        iconSize: [25, 25],
        popupAnchor: [1, -34],
        tooltipAnchor: [16, -28]
    }
})
const LeafIcon = L.Icon.extend({
    options: {
        iconSize: [40, 40], //30,30
        iconAnchor: [5, 5], //12,41
        popupAnchor: [15, 0],//1,34
        tooltipAnchor: [16, -28],
        shadowAnchor: [4, 62]
    }
});

L.Marker.prototype.options.icon = iconDefault;

var pointInPolygon = require('point-in-polygon');

@Component({
    selector: 'app-map',
    templateUrl: './map.component.html',
    styleUrls: ['./map.component.scss'],
    encapsulation: ViewEncapsulation.None,
    animations: fuseAnimations,
    providers: [PoligonService]
})
export class MapComponent implements AfterViewInit {


    capitals: string = '/assets/data/usa-capitals.geojson';
    private _filterText: string = '';
    public get filterText(): string {
        return this._filterText;
    }
    public set filterText(v: string) {
        this._filterText = v.trim().toLowerCase();
    }

    private map;
    public companyId: number
    public envanterMarkerOpen = false;
    public markerMasterOpen = false;
    public containerMarkerOpen = false;
    public markerOpen = false;
    private polygonMarkerOpen = false;
    public autoComplateContainers: Array<Container> = [];
    public _containers: Array<Container> = [];
    private poligons = [];
    public envanterList: Array<Envanter> = [];
    public carlist: Array<Car>
    public containerMarkerList: Array<{container:Container,marker:L.Marker}> = [];
    public carMarkerList: Array<any> = [];
    public envanterMarkerList: Array<any> = [];

    constructor(
        private _dialog: MatDialog,
        private _toastService: ToasterService,
        private _translateService: TranslateService,
        private _containerService: ContainerService,
        private _poligonService: PoligonService,
        private _carService: CarService,
        private appConfigService: AppInitializationService,
        private _deviceService: DeviceService,
        private _envanterService: EnvanterService,
        private _dateConvertService: DateConvertService,
    ) {

    }

    public drawControl = new L.Control.Draw({
        position: 'topleft',
        draw: {
            polyline: true,
            polygon: true,
            circle: false,
            rectangle: false,
            marker: false,
            circlemarker: false,
        }
    });


    public get MapTileUrl(): string {
        return 'http://tile.openstreetmap.org/{z}/{x}/{y}.png';
    }

    async ngAfterViewInit(): Promise<void> {
        await this.initMap();
        await this.getContainerList();
        await this.getPoligonList();
        await this.drawingPolygons();
        await this.makeContainerMarkers(this.map);
        await this.makeCarMarkers();
        await this.makeEnvanterMarker();

        setInterval(async () => {
            await this.onContainerMarkerRemove();
            await this.onPoligonRemove();
            await this.onEnvanterMarkerRemove();
            await this.getContainerList();
            await this.getPoligonList();
            await this.drawingPolygons();
            await this.makeContainerMarkers(this.map);
            await this.makeEnvanterMarker();
        }, 1000 * 60 * 5)

        setInterval(async () => {
            await this.onCarMarkerRemove();
            await this.makeCarMarkers();

        }, 1000 * 60 * 1)

    }

    onSearchListen(e) {
        if (e) {
            e.stopPropagation();
        }
        this.autoComplateContainers = this._containers.filter(x=>x.name.toLowerCase().includes(this.filterText))
    }
    onAutoComplateClick(item:Container){
        this.map.setView(new L.LatLng(item.latitude, item.longitude), 20)
        var change = this.containerMarkerList.find(x=>x.container.id == item.id)
        change.marker.openPopup();
    }

    //#region operation to get model list
    /**
     * operation to get container list
     * @returns 
     */
    private async getContainerList(): Promise<Array<Container>> {
        try {
            this._containers = await this._containerService.getAllContainerDetail(parseInt(localStorage.getItem("CompanyID")));
        } catch (error) {
            console.warn(error);
            return [];
        }
    }

    /**
     * operation to get polygon list
     */
    async getPoligonList() {
        this.poligons = []
        try {
            this.poligons = await this._poligonService.getPoligons(this.companyId);
        } catch (error) {
            console.warn(error);
        }
    }

    /**
     * operation to get car list
     */
    async getCarList() {
        try {
            this.carlist = await this._carService.getCars(this.companyId);
        } catch (error) {
            console.warn(error);
        }
    }
    //#endregion

    /**
     * map init operation
     */
    private async initMap(): Promise<void> {
        this.companyId = parseInt(localStorage.getItem("CompanyID"));

        await this.getCarList();

        this.map = L.map('map', {
            center: [39.09766, 34.56039],
            zoom: 6
        });

        this.drawInit(this.map);
        this.mySetLocation(this.map);

        const tiles = L.tileLayer(
            this.MapTileUrl, {
            maxZoom: 19,
            minZoom: 5,
            attribution: 'AKILLI-ATIK-SİSTEMİ'
        });

        tiles.addTo(this.map);

        L.control.browserPrint({ position: 'topleft', title: 'Print ...' }).addTo(this.map);

        this.map.on('draw:drawstart', async e => {
            this.polygonMarkerOpen = true;

            if (this.markerOpen || this.markerMasterOpen || this.containerMarkerOpen) {
                this._toastService.toastFail(this._translateService.instant("STOP_MARKING"))
                this.map.removeControl(this.drawControl);
                this.map.addControl(this.drawControl)

            }
        });

        this.map.on('draw:drawstop', async e => {
            this.polygonMarkerOpen = false;
        });

        this.map.on("click", async e => {

            //add container
            if (this.containerMarkerOpen && !this.markerOpen && !this.polygonMarkerOpen) {
                this.mapAddContainerClick(e);
            }

            //set container location
            if ((this.markerOpen) && !this.polygonMarkerOpen) {
                this.setContainerLocation(e);
            }

            //set garbage location
            if ((this.markerMasterOpen) && !this.polygonMarkerOpen) {
                this.mapAddGarbageClick(e);
            }

            // set inventory location
            if ((this.envanterMarkerOpen) && !this.polygonMarkerOpen) {
                this.openEnvanterAddForm(e.latlng.lat, e.latlng.lng);
            }
        });

    }

    /**
     * Adding garbage when clicking on the map
     * @param e
     */
    public mapAddGarbageClick(e: any) {
        const marker = L.marker([e.latlng.lat, e.latlng.lng]);
        const formModel = Object.assign({ lat: e.latlng.lat, lng: e.latlng.lng }, e);
        const dialog = this._dialog.open(GarbageCenterFormComponent, {
            data: formModel,
            disableClose: false
        });

        dialog.componentInstance.done.subscribe(async () => {

            this.markerOpen = false;

            this.containerDeleteWithOutPolygon(dialog.componentInstance.selectedContainerId)

            dialog.componentInstance.selectedPolygons.forEach(x => {
                let poligonDetail = new PoligonDetail();
                poligonDetail.poligonId = x.id;
                poligonDetail.discriminator = "garbage-center";
                poligonDetail.discriminatorId = dialog.componentInstance.selectedContainerId
                var garbage = this.containerAdd(poligonDetail)
                garbage ? this._toastService.toastSuccess() : this._toastService.toastFail();
            })

            marker.addTo(this.map);

        });

        dialog.componentInstance.close.subscribe(async (value: string) => {

            this.markerOpen = false;

            if (value != "") {
                this._toastService.toastFail(value);
            }

            this.map.removeLayer(marker);
        });
    }

    /**
     * operation of set container location
     * @param e
     */
    public setContainerLocation(e: any) {
        const marker = L.marker([e.latlng.lat, e.latlng.lng]);
        const formModel = Object.assign({ lat: e.latlng.lat, lng: e.latlng.lng }, e);
        const dialog = this._dialog.open(MarkerFormComponent, {
            data: formModel,
            disableClose: false
        });
        let control = false;

        dialog.componentInstance.done.subscribe(async () => {

            this.markerOpen = false;

            if (dialog.componentInstance.selectedContainer.containerType == true) {
                marker.addTo(this.map);
                return;
            }

            this.poligons.forEach(poligon => {

                var poligonList = new Array();
                let points = poligon.points.split("*");

                points.forEach(item => {
                    var array = new Array();
                    var location = item.split([","]);
                    array.push(parseFloat(location[0]), parseFloat(location[1]))
                    poligonList.push(array);
                });

                var inPolygon = pointInPolygon([formModel.lat, formModel.lng], poligonList); // is the marker inside the polygon?

                if (inPolygon) {
                    control = true;
                    let poligonDetail = new PoligonDetail();
                    poligonDetail.poligonId = poligon.id;
                    poligonDetail.discriminator = "container";
                    poligonDetail.discriminatorId = dialog.componentInstance.selectedContainer.id
                    this.containerAdd(poligonDetail)
                }

            })

            marker.addTo(this.map);

            if (!control) {
                this.containerDeleteWithOutPolygon(dialog.componentInstance.selectedContainer.id)
            }

            this._toastService.toastSuccess();

        });

        dialog.componentInstance.close.subscribe(async (value: string) => {

            this.markerOpen = false;

            if (value != "") {
                this._toastService.toastFail(value);
            }

            this.map.removeLayer(marker);
        });

    }

    /**
     * Adding container when clicking on the map
     * @param e map click event  
     */
    public mapAddContainerClick(e: any) {

        const dialog = this._dialog.open(MapContainerFormComponent, {
            data: { lat: e.latlng.lat, lng: e.latlng.lng },
            disableClose: false
        });

        dialog.componentInstance.operation = "create";
        dialog.componentInstance.added.subscribe(async (model: Container) => {

            const marker = L.marker([e.latlng.lat, e.latlng.lng]);
            const formModel = Object.assign({ lat: e.latlng.lat, lng: e.latlng.lng }, e);

            model.latitude = e.latlng.lat;
            model.longitude = e.latlng.lng;
            let container;

            try {
                model.status = true;
                container = await this._containerService.add(model);
            } catch (error) {
                console.warn(error);

            }

            this.poligons.forEach(poligon => {

                var poligonList = new Array();
                let points = poligon.points.split("*");

                points.forEach(item => {
                    var array = new Array();
                    var location = item.split([","]);
                    array.push(parseFloat(location[0]), parseFloat(location[1]))
                    poligonList.push(array);
                });

                var inPolygon = pointInPolygon([formModel.lat, formModel.lng], poligonList); // is the marker inside the polygon?

                if (inPolygon) {
                    let poligonDetail = new PoligonDetail();
                    poligonDetail.poligonId = poligon.id;
                    poligonDetail.discriminator = "container";
                    poligonDetail.discriminatorId = container.id

                    try {
                        this.containerAdd(poligonDetail)
                    } catch (error) {
                        console.warn(error);

                    }

                }
            })

            marker.addTo(this.map);
            dialog.close();
        });

        dialog.afterClosed().subscribe(() => {
            this.containerMarkerOpen = false;
        })
    }

    /**
     * operation of deleting polygon details
     * @param discriminator_Id 
     */
    public async containerDeleteWithOutPolygon(discriminator_Id: number) {
        try {
            var poligonDetailList = await this._poligonService.getByPoligonDetail(discriminator_Id);
            await this._poligonService.removeRange(poligonDetailList)
        } catch (error) {
            console.warn(error);
        }
    }

    /**
     * operation of adding polygon details (containers)
     * @param poligonDetail poligon detail
     */
    public async containerAdd(poligonDetail: PoligonDetail) {
        try {
            var poligonDetailList = await this._poligonService.getByPoligonDetail(poligonDetail.discriminatorId);
            await this._poligonService.removeRange(poligonDetailList)
            var detail = await this._poligonService.addDetail(poligonDetail);
            return detail
        } catch (error) {
            console.warn(error);
            return undefined;
        }
    }

    /**
     * leaflet polyline and polygon event 
     * @param map 
     */
    public drawInit(map: L.map) {
        map.addControl(this.drawControl);
        map.on('draw:created', this.openPoligonForm.bind(this));
    }

    /**
     * check for overlapping of polygons
     * @param layer 
     * @returns 
     */
    public polygonOverlappingControl(layer): Boolean {

        let selectedArray = [];
        let latLangs = layer._latlngs[0];
        let poligons = [];
        var inPolygonSecond;
        var inPolygon;
        var controlone = false;
        var controltwo = false;

        for (let index = 0; index < latLangs.length; index++) {
            let newLocation = [latLangs[index].lat, latLangs[index].lng];
            selectedArray.push(newLocation);
        }

        this.poligons.forEach(poligon => {
            var poligonList = new Array();
            let points = poligon.points.split("*");

            points.forEach(item => { //item => latitude longitude information inside the points

                var array = new Array();
                var location = item.split([","]);
                inPolygon = pointInPolygon([location[0], location[1]], selectedArray);

                if (inPolygon) {
                    controlone = true;
                }

                array.push(parseFloat(location[0]), parseFloat(location[1]))
                poligonList.push(array);
            });

            poligons.push(poligonList);
        })

        selectedArray.forEach(item => {
            poligons.forEach(element => {
                inPolygonSecond = pointInPolygon([item[0], item[1]], element); // check for overlapping of polygons

                if (inPolygonSecond) {
                    controltwo = true;
                }

            });
        })
        return (controlone || controltwo) ? false : true;
    }

    /**
     * single or multiple polygon insertion form
     * @param e 
     */
    public openPoligonForm(e) {
        if (e.layerType == "polyline") {
            this.multiContainerForm(e);
        } else {

            var layer = e.layer;
            var poligonInfo = "";
            let overlapping = this.polygonOverlappingControl(layer)

            if (overlapping) {
                for (let index = 0; index < layer._latlngs[0].length; index++) {
                    const element = layer._latlngs[0][index];

                    poligonInfo += element.lat + "," + element.lng;

                    if (index < layer._latlngs[0].length - 1) {
                        poligonInfo += "*";
                    }

                }
                const formModel = new Poligon();
                formModel.points = poligonInfo;

                const dialog = this._dialog.open(PoligonFormComponent, {
                    data: formModel,
                    disableClose: false
                });
                dialog.componentInstance.done.subscribe(async (id: string) => {

                    this.LocationsInsidePolygon(layer, id);
                    this.getPoligonList();
                    this.drawingPolygons();
                    this.map.addLayer(layer);
                    this._toastService.toastSuccess();
                });
            }
            else {
                this._toastService.toastWarning(this._translateService.instant("THE_POLYGONS_OVERLAP"))
            }
        }

    }

    /**
     * multi-polygon insertion form
     * @param e 
     */
    multiContainerForm(e) {
        const dialog = this._dialog.open(MapContainerFormComponent, {
            data: new Container(),
            disableClose: false
        });
        dialog.componentInstance.operation = "update";  // tekli ekleme create - çoklu ekleme update
        dialog.componentInstance.updated.subscribe((model: Container) => {
            this.setMarkerWithPolyline(e, model);
            this._toastService.toastSuccess();
            dialog.close();
        });
    }

    /**
     * Adding containers by drawing
     * @param e map polyline event
     * @param model container
     */
    async setMarkerWithPolyline(e, model: Container) {
        var layer = e.layer;
        for (let index = 0; index < layer._latlngs.length; index++) {
            const element = layer._latlngs[index];

            var map_icon = new ContainerIcon({ iconUrl: 'assets/img/marker-icon.png' });
            const marker = L.marker([element.lat, element.lng], { icon: map_icon });
            marker.addTo(this.map);
            var deviceId = this.generateGuidMegEye();

            await this.setDeviceMultiple(model.companyId, deviceId);

            let container = new Container();
            container.deviceId = deviceId;
            container.latitude = element.lat;
            container.longitude = element.lng;
            container.companyId = model.companyId
            container.dDate = new Date();
            container.altitude = model.altitude;
            container.sValue = model.sValue;
            container.bValue = model.bValue;
            container.street = model.street + "/" + index;
            container.streetDesc = model.streetDesc + "/" + index;
            container.neighbor = model.neighbor + "/" + index;
            container.status = true;

            try {
                let containerResponse = await this._containerService.add(container);
                this.DrawPolygonInContainerControl(containerResponse);

            } catch (error) {
                console.warn(error);

            }
        }
    }

    /**
     * device add operation
     * @param companyId company id
     * @param deviceId device id
     * @returns device id
     */
    async setDeviceMultiple(companyId, deviceId): Promise<string> {
        var _device: Device =
        {
            id: deviceId,
            firmware: "00032",
            model: "2",
            periot: "15",
            shakeCount: "120",
            sonicActive: "1",
            sonicFilte: "10",
            sonicTolerans: "20",
            sonicMeasure: "15",
            msgTyr: "3",
            msgStanby: "35000",
            runType: "1",
            gpsRepeat: "20",
            gpsTime: "25",
            gpsPeriot: "8",
            batMin: "320",
            batGpMin: "380",
            shakeWait: "3",
            distanceTime: "5",
            distanceValue: "15",
            empty1: "0",
            empty2: "0",
            empty3: "0",
            batMultiplier: "1000",
            solarMultiplier: "1000",
            serialNumber: "DP0000000001",
            apn: "internet",
            hostRequestWeb: "http://212.154.111.45:10001",
            hostRequestEXT: "/custom_get_request",
            ssid: "Simulation",
            smsNumber: "5439024474",
            periotTimeOut: "20",
            heatAlarm: "800",
            updated: 0,
            companyId: companyId,
            time: new Date,
            uDate: new Date
        };
        try {
            await this._deviceService.add(_device)
            return deviceId;
        } catch (error) {
            console.warn(error);
            return null;
        }
    }

    /**
     * create uniq id
     * @returns uniq id
     */
    public generateGuidMegEye(): string {
        var toDate = new Date
        var full_date = new Date(toDate.getFullYear(), toDate.getMonth(), toDate.getDate(), toDate.getHours(), toDate.getMinutes(), toDate.getSeconds(), toDate.getMilliseconds());
        var rn = Math.floor(Math.random() * 1000000);
        var time = full_date.getTime();
        return "0" + (time.toString() + rn.toString()).slice(5, 20);
    }

    /**
    * the process of adding what's inside the polygon
    * @param layer 
    * @param id 
    */
    public LocationsInsidePolygon(layer, id) {
        let array = [];
        let latLangs = layer._latlngs[0];
        for (let index = 0; index < latLangs.length; index++) {
            let newLocation = [latLangs[index].lat, latLangs[index].lng];
            array.push(newLocation);
        }

        for (let index = 0; index < this._containers.length; index++) {
            const element = this._containers[index];

            var inPolygon = pointInPolygon([element.latitude, element.longitude], array); // is the marker inside the polygon?

            if (inPolygon) {
                let poligonDetail = new PoligonDetail();
                poligonDetail.poligonId = id;
                poligonDetail.discriminator = "container";
                poligonDetail.discriminatorId = element.id;

                try {
                    this._poligonService.addDetail(poligonDetail);
                } catch (error) {
                    console.warn(error);

                }
            }
        }
    };

    //#region Map Marker Click Control
    public onAddLocationClick(e) {
        this.markerMasterOpen = false;
        this.containerMarkerOpen = false;
        this.envanterMarkerOpen = false;
        if (this.polygonMarkerOpen) {
            this._toastService.toastFail(this._translateService.instant("STOP_THE_ACTIVE_POLYGON_SELECTION"));
            return;
        }
        this.markerOpen = true;
        this._toastService.toastWarning(this._translateService.instant("MARKING_IS_ACTIVE_PLEASE_MARK_A_PLACE_ON_THE_MAP"));
        e.stopPropagation();
    }

    public onAddContainerClick(e) {
        this.markerMasterOpen = false;
        this.markerOpen = false;
        this.envanterMarkerOpen = false;
        if (this.polygonMarkerOpen) {
            this._toastService.toastFail(this._translateService.instant("STOP_THE_ACTIVE_POLYGON_SELECTION"));
            return;
        }
        this.containerMarkerOpen = true;
        this._toastService.toastWarning(this._translateService.instant("MARKING_IS_ACTIVE_PLEASE_MARK_A_PLACE_ON_THE_MAP"));
        e.stopPropagation();
    }

    public onAddMasterLocationClick(e) {

        this.markerOpen = false;
        this.envanterMarkerOpen = false;
        this.containerMarkerOpen = false;
        if (this.polygonMarkerOpen) {
            this._toastService.toastFail(this._translateService.instant("STOP_THE_ACTIVE_POLYGON_SELECTION"));
            return;
        }
        this.markerMasterOpen = true;
        this._toastService.toastWarning(this._translateService.instant("MARKING_IS_ACTIVE_PLEASE_MARK_A_PLACE_ON_THE_MAP"));
        e.stopPropagation();
    }

    public onCancelLocationClick(e) {
        this.markerOpen = false;
        this.envanterMarkerOpen = false;
        this.markerMasterOpen = false;
        this._toastService.toastFail(this._translateService.instant("MARKING_IS_PASSIVE"));
        e.stopPropagation()
    }

    //#endregion

    /**
     * drawingPolygons 
     */
    drawingPolygons() {
        this.poligons.forEach(item => {

            var poligonList = new Array();
            let points = item.points.split("*");
            points.forEach(item => {
                var location = item.split([","]);
                poligonList.push(new L.LatLng(location[0], location[1]));
            });
            var firstpolyline = new L.polygon(poligonList, {
                color: 'gray',
                weight: 3,
                opacity: 0.3,
                smoothFactor: 1
            });
            firstpolyline.bindTooltip(item.name);

            this.map.addLayer(firstpolyline);
        })
    }

    /**
     * operation of finding my location
     * @param map 
     */
    mySetLocation(map: L.map) {

        var options = {
            enableHighAccuracy: true,
            timeout: 10000,
            maximumAge: 0
        };

        navigator.geolocation.getCurrentPosition(
            (position) => {
                console.log(position);

                let lat = position.coords.latitude;
                let long = position.coords.longitude;
                var LeafIcon = L.Icon.extend({
                    options: {
                        iconSize: [30, 30],
                        iconAnchor: [12, 41],
                        popupAnchor: [1, -34],
                        tooltipAnchor: [16, -28],
                        shadowAnchor: [4, 62]
                    }
                });

                var map_icon = new LeafIcon({ iconUrl: 'assets/img/marker.png' });
                var marker = L.marker([lat, long], { icon: map_icon });
                marker.addTo(map);

                setTimeout(() => { map.flyTo(new L.LatLng(lat, long), 11) }, 2000)

            },
            () => {
                this._toastService.toastFail(this._translateService.instant("DEVICE_LOCATION_INFORMATION_COULD_NOT_BE_OBTAINED"))
            },
            options
        );

    }

    /**
     * The operation that checks that the container polygon is inside
     * @param container Container Model
     */
    public DrawPolygonInContainerControl(container: Container) {
        this.poligons.forEach(poligon => {
            var poligonList = new Array();
            let points = poligon.points.split("*");

            points.forEach(item => {
                var array = new Array();
                var location = item.split([","]);
                array.push(parseFloat(location[0]), parseFloat(location[1]))
                poligonList.push(array);
            });

            var inPolygon = pointInPolygon([container.latitude, container.longitude], poligonList); // is the marker inside the polygon?

            if (inPolygon) {
                let poligonDetail = new PoligonDetail();
                poligonDetail.poligonId = poligon.id;
                poligonDetail.discriminator = "container";
                poligonDetail.discriminatorId = container.id;
                this.containerAdd(poligonDetail)
            }
        })
    }

    /**
    * enable add inventory marker
    * @param e click event 
    * @returns 
    */
    public onAddEnvanterClick(e) {
        this.markerOpen = false;
        this.containerMarkerOpen = false;
        this.markerMasterOpen = false;
        if (this.polygonMarkerOpen) {
            this._toastService.toastFail(this._translateService.instant("STOP_THE_ACTIVE_POLYGON_SELECTION"));
            return;
        }

        this.envanterMarkerOpen = true;
        this._toastService.toastWarning(this._translateService.instant("MARKING_IS_ACTIVE_PLEASE_MARK_A_PLACE_ON_THE_MAP"));
        e.stopPropagation();
    }

    /**
     * added inventory
     * @param lat latitude
     * @param lng longitude
     */
    public openEnvanterAddForm(lat, lng) {
        const dialog = this._dialog.open(EnvanterFormComponent, {
            data: { lat: lat, lng: lng },
            disableClose: false
        });

        dialog.componentInstance.operation = "create";
        dialog.componentInstance.added.subscribe(async (model: boolean) => {
            if (model) {
                const marker = L.marker([lat, lng]);
                marker.addTo(this.map);
            }
            if (!model) {
                this._toastService.toastFail();
            }

            dialog.close();
        });

        dialog.afterClosed().subscribe(() => {
            this.envanterMarkerOpen = false;
        })
    }

    //#region operations to add a marker to the map

    /**
     * operation of adding an container marker to the map
     * @param map 
     */
    async makeContainerMarkers(map: L.map): Promise<void> {
        this._containers.forEach(x => {
            if (x.latitude && x.longitude) {

                if (x.containerType == true) {
                    const marker = L.marker([x.latitude, x.longitude], { icon: new ContainerIcon({ iconUrl: 'assets/img/end.png' }) });
                    marker.bindPopup(() => {
                        let html = `<div> ${this._translateService.instant("TITLE")} : ${x.streetDesc}</div>`;
                        return html;
                    });
                    this.containerMarkerList.push({container:x,marker:marker})
                    marker.addTo(map)
                    return;
                }
                var calc = 0;

                if (x.device && x.device?.deviceLatestStatus) {
                    calc = (((parseInt(x.altitude) - parseInt(x.deadZone)) - (parseInt(x.device.deviceLatestStatus.mesafe) - parseInt(x.deadZone))) * 100)
                        / (parseInt(x.altitude) - parseInt(x.deadZone))
                    if (calc < 0) {
                        calc = 0;
                    }
                    else if (calc > 100) {
                        calc = 100;
                    }
                }

                var calculate = x.device?.deviceLatestStatus ? calc : -1;
                var map_icon;

                if (calculate <= this.appConfigService.apiConfig["container-msf-yellow"]) {
                    map_icon = new ContainerIcon({ iconUrl: 'assets/img/trash-green.png' });
                }
                else if (calculate <= this.appConfigService.apiConfig["container-msf-orange"]) {
                    map_icon = new ContainerIcon({ iconUrl: 'assets/img/trash-yellow.png' });
                }
                else if (calculate <= this.appConfigService.apiConfig["container-msf-red"]) {
                    map_icon = new ContainerIcon({ iconUrl: 'assets/img/trash-orange.png' })
                }
                else {
                    map_icon = new ContainerIcon({ iconUrl: 'assets/img/trash-red.png' })
                }

                const marker = L.marker([x.latitude, x.longitude], { icon: map_icon });

                var fullnessValue = calculate == -1 ? this._translateService.instant("UNDEFINED_VALUE") : calculate.toString().slice(0, 4);
                marker.bindPopup(this.setContainerMarkerPopup(x.street, x.streetDesc, fullnessValue, x.deviceId, x.name));
                this.containerMarkerList.push({container:x,marker:marker});
                marker.addTo(map)
            }
        });
    }

    /**
     * operation of adding an car marker to the map
     */
    async makeCarMarkers() {
        var map_car_icon = new LeafIcon({ iconUrl: 'assets/img/garbage-truck.png' });
        this.carlist.forEach(x => {
            if (x.eLatitude && x.eLongitude) {
                const marker = L.marker([x.eLatitude, x.eLongitude], { icon: map_car_icon });
                marker.bindPopup(this.setCarMarkerPopup(x));
                this.carMarkerList.push(marker)
                marker.addTo(this.map)
            }
        })
    }

    /**
    * operation of adding an inventory marker to the map
    */
    public async makeEnvanterMarker() {
        this.envanterList = await this._envanterService.getEnvanter(this.companyId);
        this.envanterList.forEach(x => {
            const marker = L.marker([x.latitude, x.longitude], { icon: new ContainerIcon({ iconUrl: this.appConfigService.apiConfig['api-url'] + 'envanter/' + x?.icon }) });
            var html = this.setEnvanterMarkerPopup(x);
            marker.bindPopup(html);
            marker.addTo(this.map)
            this.envanterMarkerList.push(marker)
        })
    }

    //#endregion

    //#region set markers popups

    /**
     *  set container marker popup
     * @param street address
     * @param streetDesc address detail
     * @param fullness occupancy
     * @param deviceID device id of the container
     * @param name Container Name
     * @returns html string
     */
    setContainerMarkerPopup(street: string, streetDesc, fullness: string, deviceID: string, name: string): string {
        let html = `<div> ${this._translateService.instant("OCCUPANCY")} : % ${fullness}</div>`;
        if (deviceID != null) {
            html += `<div> ${"No"}: ${deviceID}</div>`;
        }
        html += `<div> ${this._translateService.instant("NAME")}: ${name}</div>`;
        html += `<div> ${this._translateService.instant("TITLE")}: ${streetDesc}</div>`;
        html += `<div> ${this._translateService.instant("STREET")}: ${street}</div>`;
        html += `<div> Detay: <a href="/apps/container/view?deviceId=${deviceID}" target="_blank">Git</a> </div>`;

        return html;
    }

    /**
     * set car marker popup
     * @param data car model
     * @returns html string
     */
    setCarMarkerPopup(data: Car): string {
        let html = `<div>${this._translateService.instant("PLATE")} : ${data.plate}</div>`;
        return html;
    }

    /**
     * set envanter marker popup
     * @param item envanter model
     * @returns html string
     */
    setEnvanterMarkerPopup(item: Envanter) {
        let html = `<div> ${this._translateService.instant("NAME")} : ${item.name}</div>`;
        html += `<div> ${this._translateService.instant("TYPE")}: ${item.type}</div>`;
        html += `<div> ${this._translateService.instant("DESCRIPTION")}: ${item.description}</div>`;
        return html;
    }

    //#endregion


    //#region Deletion Operations

    /**
     * deleion of polygons
     */
    public async onPoligonRemove() {

        for (let i in this.map._layers) {
            if (this.map._layers[i]._path != undefined) {
                try {
                    this.map.removeLayer(this.map._layers[i]);
                }
                catch (e) {
                    console.log("problem with " + e + this.map._layers[i]);
                }
            }
        }
    }

    /**
     * deletion of container marker
     */
    public async onContainerMarkerRemove() {
        for (let i = 0; i < this.containerMarkerList.length; i++) {
            this.map.removeLayer(this.containerMarkerList[i].marker);
        }
        this.containerMarkerList = [];
    }

    /**
     * deletion of car marker
     */
    public async onCarMarkerRemove() {
        for (let i = 0; i < this.carMarkerList.length; i++) {
            this.map.removeLayer(this.carMarkerList[i]);
        }
        this.carMarkerList = [];
    }

    /**
     * deletion of inventory marker
     */
    public async onEnvanterMarkerRemove() {
        for (let i = 0; i < this.envanterMarkerList.length; i++) {
            this.map.removeLayer(this.envanterMarkerList[i]);
        }
        this.envanterMarkerList = [];
    }

    //#endregion

}
